<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="启用状态">
              <j-dict-select-tag
                v-model="queryParam.usedStatus"
                placeholder="请选择启用状态"
                dictCode="obj_status"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="奖品类型">
              <j-dict-select-tag
                v-model="queryParam.type"
                placeholder="请选择启用状态"
                dictCode="prize_type"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"
            ><a-icon type="delete" />删除</a-menu-item
          >
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        :columns="columns"
        size="middle"
        :dataSource="dataSource"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        rowKey="id"
        ref="table"
        bordered
        :pagination="ipagination"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="imgSlot" slot-scope="text, record">
          <span v-if="!text" style="font-size: 12px; font-style: italic"
            >无图片</span
          >
          <img
            v-else
            :src="getAvatarView(record.prizesImage)"
            alt=""
            style="
              max-width: 150px;
              max-height: 50px;
              font-size: 12px;
              font-style: italic;
            "
          />
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record.id)">删除</a>
        </span>

        <!-- 字符串超长截取省略号显示 -->
        <span slot="prizesImage" slot-scope="text">
          <j-ellipsis :value="text" :length="25" />
        </span>
        <!-- 字符串超长截取省略号显示-->
        <span slot="content" slot-scope="text">
          <j-ellipsis :value="text" />
        </span>
      </a-table>
    </div>

    <integral-prize-modal
      ref="modalForm"
      :dataSource="dataSource"
      @ok="modalFormOk"
    ></integral-prize-modal>
  </a-card>
</template>

<script>
import { getAction, postAction } from '@/api/manage';
import '@/assets/less/TableExpand.less';
import JInput from '@/components/jeecg/JInput';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import IntegralPrizeModal from './modules/IntegralPrizeModal';

export default {
  name: 'IntegralPrize',
  mixins: [JeecgListMixin],
  components: {
    JInput,
    IntegralPrizeModal,
  },
  data() {
    return {
      description: '奖品兑换管理页面',
      queryParam: {},
      // 表头
      columns: [
        {
          title: '奖品名称',
          align: 'center',
          dataIndex: 'prizesName',
          ellipsis: true,
          // customRender: function (text) {
          //   return !text
          //     ? ''
          //     : text.length > 12
          //     ? text.substr(0, 12) + '...'
          //     : text;
          // },
        },
        {
          title: '奖品类型',
          align: 'center',
          dataIndex: 'type_dictText',
        },
        {
          title: '奖品图片',
          align: 'center',
          dataIndex: 'prizesImage',
          height: '50px',
          width: '150px',
          scopedSlots: { customRender: 'imgSlot' },
        },
        /*{
            title:'奖品介绍',
            align:"center",
            dataIndex: '奖品介绍'
          },*/
        {
          title: '总数量',
          align: 'center',
          dataIndex: 'quantity',
        },
        {
          title: '剩余数量',
          align: 'center',
          dataIndex: 'remainNum',
          /*customRender:function (text) {
              return !text?"--":text === 0 ? "--" : text
            }*/
        },
        /*{
            title:'消耗积分',
            align:"center",
            dataIndex: 'integral'
          },*/
        /*{
            title:'关联活动',
            align:"center",
            dataIndex: 'activityType_dictText'
          },*/
        {
          title: '启用状态',
          align: 'center',
          dataIndex: 'usedStatus_dictText',
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime',
          width: 180,
          /*customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }*/
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 150,
          height: 50,
          //fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: process.env.VUE_APP_CMS_MARKETING + '/market/prize/list',
        delete: process.env.VUE_APP_CMS_MARKETING + '/market/prize/delete',
        deleteBatch:
          process.env.VUE_APP_CMS_MARKETING + '/market/prize/deleteBatch',
        exportXlsUrl:
          process.env.VUE_APP_CMS_MARKETING + '/market/prize/exportXls',
      },
      dictOptions: {},
    };
  },
  computed: {},
  created() {},
  methods: {
    getAvatarView: function (avatar) {
      return process.env.VUE_APP_FILE_PATH + avatar;
    },
    // 单个删除
    handleDelete: function (id) {
      if (!this.url.delete) {
        this.$message.error('请设置url.delete属性!');
        return;
      }
      var that = this;
      this.$confirm({
        title: '确认删除',
        content: '是否删除选中数据?',
        onOk: function () {
          that.loading = true;
          postAction(that.url.delete, { id: id })
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.loadData(1);
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        },
      });
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    // 批量删除
    batchDel: function () {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function () {
            that.loading = true;
            postAction(that.url.deleteBatch, { ids: ids })
              .then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.loadData(1);
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          },
        });
      }
    },
    loadData2() {
      this.dataSource = [];
      getAction(this.url.list, this.queryParam).then((res) => {
        if (res.success) {
          this.dataSource = res.result.records;
          console.log('dataSource', this.dataSource);
        }
      });
    },
    initDictConfig() {},
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.loadData();
    },
  },
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
